import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class GetInstantOfferByAdSellerUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Service} deps.getInstantOfferByAdSellerService
   */
  constructor({getInstantOfferByAdSellerService}) {
    super()

    this._getInstantOfferByAdSellerService = getInstantOfferByAdSellerService
  }

  @tracer({metric: 'GetInstantOfferByAdSellerUseCase#execute'})
  @inlineError
  execute({adId, simulate} = {}) {
    return this._getInstantOfferByAdSellerService
      .execute({
        adId,
        simulate
      })
      .then(([error, instantOfferVO]) => (error ? Promise.reject(error) : instantOfferVO.toJSON()))
  }
}
